import React from "react";
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';

import './index.scss';
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const params = new URLSearchParams(document.location.search);
window.playerId = params.get("playerId");
window.frameId = params.get("iframeId");
window.duration = params.get("duration");

document.addEventListener('DOMContentLoaded', function(event) {
  window.parent.postMessage({'event': 'loaded', 'frameId': window.frameId}, '*')
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Router>
    <App />
  </Router>
);

serviceWorker.register({
  onUpdate: registration => {
    console.info(
        'Received a service worker update, unregister old service worker and restart browser',
    );
    registration.unregister().then(() => {
      window.location.reload();
    });
  },
  onSuccess: registration => {
    console.log('New service worker loaded');
  },
});
